import { render, staticRenderFns } from "./tipofday.vue?vue&type=template&id=530f3aef&scoped=true&"
import script from "./tipofday.vue?vue&type=script&lang=js&"
export * from "./tipofday.vue?vue&type=script&lang=js&"
import style0 from "./tipofday.vue?vue&type=style&index=0&id=530f3aef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530f3aef",
  null
  
)

export default component.exports